// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/star/yellow-star-bg.png");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../assets/star/star.svg");
var ___CSS_LOADER_URL_IMPORT_2___ = require("../../assets/star/blue-star-bg.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Star__star___2ud4b{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-repeat:no-repeat;background-size:contain;-webkit-mask:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ") no-repeat center;mask:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ") no-repeat center;-webkit-mask-size:100% 100%;mask-size:100% 100%}.Star__blue___3AUUs{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ")!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"star": "Star__star___2ud4b",
	"blue": "Star__blue___3AUUs"
};
module.exports = ___CSS_LOADER_EXPORT___;
